<div class="login-container">
  <!-- LOGIN CARD -->
  <div class="login-card">
    <!-- FORM LOGIN -->
    @if (!viewReset()) {
      <form class="login-card-form" [formGroup]="formLogin" (ngSubmit)="login()" autocomplete="off">
        <div class="brand-line">
          <!-- BRAND -->
          <img class="brand-img" src="{{ logoUrl }}" alt="LOGO app" />
          <!-- BRAND TITLE -->
          <!-- <div class="brand-title">
          <h1 class="main">{{gTexts.appName}}</h1>
          <div class="side">{{ gTexts.appDesc }}</div>
        </div> -->
        </div>
        <!-- FORM TITLE -->
        <div class="form-title">
          <h2 class="main">{{ labels.loginWelcome }}</h2>
          <div class="side">{{ labels.loginInstructions }}</div>
        </div>
        <!-- USER -->
        <mat-form-field appearance="outline">
          <mat-icon fontSet="material-icons" matPrefix>person</mat-icon>
          <mat-label>{{ labels.user }}</mat-label>
          <input matInput formControlName="email" autocomplete="username" />
          @if (formLogin.controls['email'].hasError('required')) {
            <mat-error>{{ labels.userIsRequired }}</mat-error>
          }
          @if (formLogin.controls['email'].hasError('email')) {
            <mat-error>{{ labels.errorInvalidUser }}</mat-error>
          }
        </mat-form-field>
        <!-- PASSWORD -->
        <mat-form-field appearance="outline">
          <mat-icon matPrefix fontSet="material-icons">lock</mat-icon>
          <mat-label>{{ labels.password }}</mat-label>
          <input
            [type]="hide() ? 'password' : 'text'"
            matInput
            formControlName="password"
            autocomplete="current-password"
          />
          @if (formLogin.controls['password'].hasError('required')) {
            <mat-error>{{ labels.passwordIsrequired }}</mat-error>
          }
          <button
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide()"
            [disabled]="loading() || duoWait()"
            (click)="clickEvent($event)"
            matIconButton
            type="button"
            matSuffix
          >
            <mat-icon fontSet="material-icons">{{ hide() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <!-- DUO LOADING -->
        @if (duoWait()) {
          <div class="duo-overlay">
            <div class="duo-pop">
              <div class="login-load-status">
                <img src="{{ duoLogoUrl }}" priority alt="Duo logo" />
                <mat-spinner></mat-spinner>
                <p>{{ labels.waitingDuo }}</p>
              </div>
            </div>
          </div>
        }
        <!-- FORM ACTIONS -->
        <div class="login-form-actions">
          <button [disabled]="formLogin.invalid || loading() || !recaptchaReady()" type="submit" mat-flat-button>
            <mat-icon fontSet="material-icons">login</mat-icon><span>{{ labels.loginButton }}</span>
          </button>
          <button [disabled]="loading()" (click)="toggleHelp(true)" type="button" mat-button>
            <mat-icon fontSet="material-icons">support</mat-icon><span>{{ labels.recoverPassword }}</span>
          </button>
          <button (click)="verEstadoServicios()" type="button" mat-button>
            <mat-icon fontSet="material-icons">monitor_heart</mat-icon><span>Estado de los servicios</span>
          </button>
        </div>
      </form>
    } @else {
      <!-- FORM RESET -->
      <form class="login-card-form" [formGroup]="resetLogin" (ngSubmit)="reset()" autocomplete="off">
        <div class="brand-line">
          <!-- BRAND -->
          <img class="brand-img" src="{{ logoUrl }}" alt="AGD logo" />
        </div>
        <!-- FORM TITLE -->
        <div class="form-title">
          <h2 class="main">Generaremos una nueva contraseña</h2>
          <div class="side">Ingresá el mail con el que estás registrado</div>
        </div>
        <!-- EMAIL -->
        <mat-form-field appearance="outline">
          <mat-icon fontSet="material-icons" matPrefix>email</mat-icon>
          <mat-label>Correo Electrónico</mat-label>
          <input matInput formControlName="email" autocomplete="username" />
          @if (resetLogin.controls['email'].hasError('required')) {
            <mat-error>{{ labels.userIsRequired }}</mat-error>
          }
          @if (resetLogin.controls['email'].hasError('email')) {
            <mat-error>{{ labels.errorInvalidUser }}</mat-error>
          }
        </mat-form-field>
        <!-- FORM ACTIONS -->
        <div class="login-form-actions">
          <button [disabled]="resetLogin.invalid || loading()" type="submit" mat-flat-button>
            <mat-icon fontSet="material-icons">lock_open</mat-icon><span>Resetear Contraseña</span>
          </button>
          <button [disabled]="loading()" (click)="toggleHelp(false)" type="button" mat-button>
            <mat-icon fontSet="material-icons">arrow_back</mat-icon><span>Cancelar</span>
          </button>
        </div>
      </form>
    }

    <!-- DISCLAIMER -->
    <div class="login-card-footer">
      <!-- reCAPTCHA DISCLAIMER -->
      <p class="recaptcha-disclaimer">
        Este sitio está protegido por reCAPTCHA y se aplican la
        <a href="https://policies.google.com/privacy" target="_blank">Política de Privacidad</a> y los
        <a href="https://policies.google.com/terms" target="_blank">Términos de Servicio</a> de Google.
      </p>
      <!-- AGD DISCLAIMER -->
      <div class="img-container">
        <img src="{{ brandLogoUrl }}" alt="Logo AGD" />
      </div>
      <div class="line">
        <b class="main">{{ gTexts.companyName }}</b>
        <span class="side">{{ gTexts.copyright }}</span>
      </div>
    </div>
    <!-- LOADER -->
    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
